module.exports = __webpack_public_path__ + "img/qa_05.13f3e8a0.png";